module.exports = __webpack_public_path__ + "img/pizza_dough_ingredients.f43df409.jpg";